<template>
  <div class="container flex flex-column items-center">
    <div class="top">
      <el-carousel height="250px">
        <el-carousel-item>
          <a class="car-item"></a>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="btn-group flex flex-row items-center">
      <router-link
        :to="{path:'detail',query:{id: `350`}}"
        class="btn-group__item flex flex-column items-center justify-center"
      >
        <i class="glyphicon glyphicon-thumbs-up"></i>
        <span>服务承诺</span>
      </router-link>
      <router-link
        :to="{path:'details',query:{id: `20`}}"
        class="btn-group__item flex flex-column items-center justify-center"
      >
        <span>用户须知</span>
      </router-link>
      <router-link :to="{path:'list',query:{type: `10`}}" class="btn-group__item flex flex-column items-center justify-center">
        <span>办事指南</span>
        
      </router-link>
      <router-link
        :to="{path:'details',query:{id: `12`}}"
        class="btn-group__item flex flex-column items-center justify-center"
      >
        <span>收费标准</span>
      </router-link>
      <a
        href="http://ccpay.thiscc.com/indexPc.html"
        target="_blank"
        class="btn-group__item flex flex-column items-center justify-center"
      >
        <span>网银缴费</span>
      </a>
      <router-link
        :to="{path:'details',query:{id: `14`}}"
        class="btn-group__item flex flex-column items-center justify-center"
      >
        <span>手机缴费</span>
      </router-link>
      <router-link :to="{path:'list',query:{type: `13`}}" class="btn-group__item flex flex-column items-center justify-center">
        <span>营业网点</span>
      </router-link>
      <router-link
        :to="{path:'details',query:{id: `19`}}"
        class="btn-group__item flex flex-column items-center justify-center"
      >
        <span>报装资料</span>
      </router-link>
      <router-link :to="{path:'list',query:{type: `14`}}" class="btn-group__item flex flex-column items-center justify-center">
        <span>联系方式</span>
      </router-link>
    </div>
    <div class="line flex flex-row items-center justify-between">
      <div class="banner">
        <el-carousel height="220px">
          <el-carousel-item v-for="item in banner" :key="item">
            <img :src="item" width="350" height="220" />
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="news-box">
        <el-tabs value="first" class="card-mine" type="card">
          <el-tab-pane label="公司动态" name="first">
            <table
              border="1"
              style=" border-collapse:collapse;border-spacing:50; border:1px  solid  #FFFFFF;margin:auto;width: 500px;"
            >
              <tbody>
                <tr
                  v-for="(item,index) in comAct"
                  :key="index"
                  style="background: #e5efeb; text-align: center;height: 44px;"
                >
                  <td style="width: 80%;">
                    <router-link :to="{path:'detail',query:{id:item.id}}">{{ item.title }}</router-link>
                  </td>
                  <td style="width: 20%;">{{ item.writeTime }}</td>
                </tr>
              </tbody>
            </table>
          </el-tab-pane>
          <el-tab-pane label="行业资讯" name="second">
            <table
              border="1"
              style=" border-collapse:collapse;border-spacing:50; border:1px  solid  #FFFFFF;margin:auto;width: 500px;"
            >
              <tbody>
                <tr
                  v-for="(item,index) in hyMsg"
                  :key="index"
                  style="background: #e5efeb; text-align: center;height: 44px;"
                >
                  <td style="width: 80%;">
                    <router-link :to="{path:'detail',query:{id:item.id}}">{{ item.title }}</router-link>
                  </td>
                  <td style="width: 20%;">{{ item.writeTime }}</td>
                </tr>
              </tbody>
            </table>
          </el-tab-pane>
          <el-tab-pane label="用水常识" name="third">
            <table
              border="1"
              style=" border-collapse:collapse;border-spacing:50; border:1px  solid  #FFFFFF;margin:auto;width: 500px;"
            >
              <tbody>
                <tr
                  v-for="(item,index) in ysDTO"
                  :key="index"
                  style="background: #e5efeb; text-align: center;height: 44px;"
                >
                  <td style="width: 80%;">
                    <router-link :to="{path:'detail',query:{id:item.id}}">{{ item.title }}</router-link>
                  </td>
                  <td style="width: 20%;">{{ item.writeTime }}</td>
                </tr>
              </tbody>
            </table>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="iframe-box">
        <video controls 
            class="responsive-video"
            :poster="thumbnail"
            playsinline>
          <source src="../../assets/mp4.mp4" type="video/mp4">
        </video>
      </div>
    </div>
    <div class="line flex flex-row items-center justify-between">
      <div class="line-bxo">
        <el-tabs @tab-click="moreInfo($event)" value="first" class="card-mine" type="card">
          <el-tab-pane label="出厂水质" name="first">
            <table
              border="1"
              style=" border-collapse:collapse;border-spacing:50; border:1px  solid  #FFFFFF;margin:auto;width: 390px;"
            >
              <tbody>
                <tr
                  v-for="(item,index) in priceDTO"
                  :key="index"
                  style="background: #e5efeb; text-align: center;height: 44px;"
                >
                  <td style="width: 80%;">
                    <router-link :to="{path:'detail',query:{id:item.id}}">{{ item.title }}</router-link>
                  </td>
                  <td style="width: 20%;">{{ item.writeTime }}</td>
                </tr>
              </tbody>
            </table>
          </el-tab-pane>
          <el-tab-pane label="管网水质" name="second">
            <table
              border="1"
              style=" border-collapse:collapse;border-spacing:50; border:1px  solid  #FFFFFF;margin:auto;width: 390px;"
            >
              <tbody>
                <tr
                  v-for="(item,index) in gwDTO"
                  :key="index"
                  style="background: #e5efeb; text-align: center;height: 44px;"
                >
                  <td style="width: 80%;">
                    <router-link :to="{path:'detail',query:{id:item.id}}">{{ item.title }}</router-link>
                  </td>
                  <td style="width: 20%;">{{ item.writeTime }}</td>
                </tr>
              </tbody>
            </table>
          </el-tab-pane>
          <el-tab-pane label="查看更多" name="4">查看更多</el-tab-pane>
        </el-tabs>
      </div>

      <div class="line-bxo">
        <el-tabs @tab-click="moreInfo($event)" value="first" class="card-mine" type="card">
          <el-tab-pane label="计划停水" name="first">
            <table
              border="1"
              style=" border-collapse:collapse;border-spacing:50; border:1px  solid  #FFFFFF;margin:auto;width: 390px;"
            >
              <tbody>
                <tr
                  v-for="(item,index) in stopDTO"
                  :key="index"
                  style="background: #e5efeb; text-align: center;height: 44px;"
                >
                  <td style="width: 80%;">
                    <router-link :to="{path:'detail',query:{id:item.id, type: 5}}">{{ item.title }}</router-link>
                  </td>
                  <td style="width: 20%;">{{ item.writeTime }}</td>
                </tr>
              </tbody>
            </table>
          </el-tab-pane>
          <el-tab-pane label="抢修停水" name="second">
            <table
              border="1"
              style=" border-collapse:collapse;border-spacing:50; border:1px  solid  #FFFFFF;margin:auto;width: 390px;"
            >
              <tbody>
                <tr
                  v-for="(item,index) in wxDTO"
                  :key="index"
                  style="background: #e5efeb; text-align: center;height: 44px;"
                >
                  <td style="width: 80%;">
                    <router-link :to="{path:'detail',query:{id:item.id}}">{{ item.title }}</router-link>
                  </td>
                  <td style="width: 20%;">{{ item.writeTime }}</td>
                </tr>
              </tbody>
            </table>
          </el-tab-pane>
          <el-tab-pane label="查看更多" name="5"></el-tab-pane>
        </el-tabs>
      </div>

      <div class="line-bxo">
        <el-tabs value="first" @tab-click="moreInfo($event)"  class="card-mine" type="card">
          <el-tab-pane label="政策法规" name="first">
            <table
              border="1"
              style=" border-collapse:collapse;border-spacing:50; border:1px  solid  #FFFFFF;margin:auto;width: 390px;"
            >
              <tbody>
                <tr
                  v-for="(item,index) in zcDTO"
                  :key="index"
                  style="background: #e5efeb; text-align: center;height: 44px;"
                >
                  <td style="width: 80%;">
                    <router-link :to="{path:'detail',query:{id:item.id}}">{{ item.title }}</router-link>
                  </td>
                  <td style="width: 20%;">{{ item.writeTime }}</td>
                </tr>
              </tbody>
            </table>
          </el-tab-pane>
          <el-tab-pane label="查看更多" name="7"></el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <div class="line flex flex-column items-center justify-between" style="margin-bottom:10px;">
      <div class="yg-box-top">
        <div class="yg-box-top__item">企业文化</div>
      </div>
      <div style="width:100%">
        <vue-seamless-scroll :data="imageList" :class-option="classOption" class="seamless-warp2">
          <ul class="item">
            <li v-for="(item, index) in imageList" :key="index">
              <el-image :src="item" fit="contain" style="width: 450px; height: 337px"></el-image>
            </li>
          </ul>
        </vue-seamless-scroll>
      </div>
    </div>
  </div>
</template>

<script>
import vueSeamlessScroll from "vue-seamless-scroll";
import { getArticlePage, imageHonor } from "@/axios/front";
export default {
  components: {
    [vueSeamlessScroll.name]: vueSeamlessScroll
  },
  data() {
    return {
      banner: [
        require("../../assets/图片1.png"),
        require("../../assets/图文2.jpg"),
        require("../../assets/图文3.jpg"),
        require("../../assets/图文4.jpg"),
        require("../../assets/图文5.jpg"),
      ],
      comAct: [],
      listData5: [1, 2],
      hyMsg: [],
      ysDTO: [],
      priceDTO: [],
      gwDTO: [],
      stopDTO: [],
      wxDTO: [],
      zcDTO: [],
      imageList: [],
      classOption: {
        limitMoveNum: 4,
        direction: 2,
        step: 1
        // singleWidth: 300
      }
    };
  },
  methods: {
    handleImageList() {
      imageHonor(`2`).then(res => {
        this.imageList = res.data;
      });
    },
    moreInfo(event) {
      if (event.name - 0 > 0) {
        this.$router.push({ path: "list", query: { type: event.name } });
      }
    },
    initArticle(type) {
      let newType = { typeId: type };
      getArticlePage({
        page: 1,
        limit: 4,
        typeId: type
      }).then(res => {
        if (res.status === 200) {
          if (type === "1") this.comAct = res.records;
          if (type === "2") this.hyMsg = res.records;
          if (type === "3") this.ysDTO = res.records;
          if (type === "4") this.priceDTO = res.records;
          if (type === "5") this.stopDTO = res.records;
          if (type === "7") this.zcDTO = res.records;
          if (type === "19") this.gwDTO = res.records;
        }
      });
    }
  },
  mounted() {
    this.handleImageList();
    this.initArticle("1");
    this.initArticle("2");
    this.initArticle("3");
    this.initArticle("4");
    this.initArticle("5");
    this.initArticle("7");
    this.initArticle("19");
  }
};
</script>

<style>
.responsive-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover; 
}
.card-mine .el-tabs__nav-scroll {
  border: none;
  background: #337ab7;
}
.card-mine > .el-tabs__header .el-tabs__nav {
  border: none !important;
  color: #ffffff !important;
}
.card-mine .el-tabs__item {
  border: none !important;
  color: #ffffff !important;
}
.card-mine > .el-tabs__header .el-tabs__item.is-active {
  background: #00a6de;
  border: none;
  color: #fff !important;
}
.card-mine > .el-tabs__header .el-tabs__item {
  border: none !important;
}
.card-mine > .el-tabs__header .el-tabs__nav {
  border: none !important;
}
.card-mine > .el-tabs__header {
  margin: 0 !important;
}
</style>

<style lang="scss" scoped>
.seamless-warp2 {
  overflow: hidden;
  height: 337px;
  width: 1200px;
  ul.item {
    width: auto;
    height: 400px;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: row;
    li {
      float: left;
      display: block;
      // margin-right: 10px;
    }
  }
}
// .ul-item {
//   list-style: none;
//   margin: 0;
//   padding: 0;
//   width: auto;
//   &.random {
//     display: flex;
//     width: auto;
//   }
//   &.decimal {
//     width: 670.4px;
//   }
//   &.ul-item2 {
//     width: 0;
//   }
//   .li-item {
//     float: left;
//     width: 300px;
//     height: 400px;
//   }
// }

.container {
  .yg-box-top {
    &__item {
      width: 96px;
      height: 40px;
      line-height: 40px;
      color: #fff;
      text-align: center;
      background: #00a6de;
    }
    width: 100%;
    height: 40px;
    background: #337ab7;
  }
  .line-bxo {
    table {
      font-size: 14px;
      a {
        color: #337ab7;
      }
    }
    width: 390px;
    height: 220px;
  }
  .iframe-box {
    iframe {
      border: none;
    }
    width: 295px;
    height: 220px;
    position: relative;
  }
  .news-box {
    table {
      font-size: 14px;
      a {
        color: #337ab7;
      }
    }
    width: 500px;
    height: 220px;
  }
  .banner {
    width: 350px;
    height: 220px;
  }
  .line {
    width: 1200px;
    height: auto;
    margin-top: 10px;
  }
  .btn-group__item:hover {
    background-color: #286090;
  }
  .btn-group {
    &__item:last-child {
      border: none;
      font-size: 18px;
    }
    &__item {
      cursor: pointer;
      flex: 1;
      height: 100%;
      border-right: 1px solid #2e6da4;
      color: #fff;
    }
    width: 1200px;
    height: 102px;
    background-color: #337ab7;
    border-radius: 5px;
    margin-top: 10px;
    overflow: hidden;
  }
  .top {
    width: 100%;
  }
  width: 100%;
  height: auto;
}
.car-item {
  width: 100%;
  height: 250px;
  display: block;
  width: 100%;
  background-image: url(https://oss-websit.oss-cn-shenzhen.aliyuncs.com/JS/images/首页1.jpg);
  background-size: 100% 100%;
  background-position: center center;
}
</style>


// WEBPACK FOOTER //
// src/front/home/Home.vue